<template>
  <group 
    key-prefix="image"
    :config="{...config, draggable}"
    @mouse:over="$emit('mouse:over', $event)"
    @mouse:out="$emit('mouse:out', $event)"
    @mouse:down="$emit('mouse:down', $event)"
    @mouse:up="$emit('mouse:up', $event)"
  >
    <v-image 
      v-if="!!image"
      :key="`image-${name}`"
      :config="{...shapeConfig, image}"
    />
    <Label
      v-if="!hideLabel"
      ref="label"
      v-bind="labelBackgroundProps"
      :config="labelConfig"
      :scale="labelScale"
      :background-color="labelBackgroundColor"
    />
  </group>
</template>

<script>
import withLabel from './mixins/withLabel'
import basicShape from './mixins/basicShape'
import Group from './Group'
export default {
  name: 'DrawImage',
  components: {Group},
  mixins: [withLabel, basicShape],
  props: {
    image: {
      type: Image, // Image can be instantiated in scripts
    },
    height: {
      validator (value) {return value == null || !isNaN(value)},
      default: null
    },
    width: {
      validator (value) {return value == null || !isNaN(value)},
      default: null
    },
    color: {
      type: String,
      default: null
    }
  },
  data () {
    return {}
  },
}
</script>